const { isNil } = require("lodash");

const QuestionPrototype = {
  validate: () => {
    throw "must implement validate";
  },

  serialize: () => {
    throw "must implement serialize";
  },
};

const SingleSelectPrototype = {
  ...QuestionPrototype,

  serialize: ({ eligibility }) =>
    eligibility.map(({ criteria }) => ({
      valid: Array.isArray(criteria) ? criteria.join() : criteria,
    })),
};

const RangeSelectPrototype = {
  ...QuestionPrototype,

  serialize: ({ eligibility }) =>
    eligibility.map((rule) => {
      if (!rule || !rule.criteria) {
        return { valid: null };
      }

      const { min, max } = rule.criteria;
      if (isNil(min) && isNil(max)) return { valid: null };
      if (isNil(max) && !isNil(min)) return { valid: `≥ ${String(min)}` };
      if (isNil(min) && !isNil(max)) return { valid: `≤ ${String(max)}` };
      return { valid: `${String(min)} - ${String(max)}` };
    }),
};

const DateOfBirthPrototype = {
  ...QuestionPrototype,

  serialize: ({ eligibility }) =>
    eligibility.map((rule) => {
      if (!rule || !rule.criteria) {
        return { valid: null };
      }

      const { min, max, value, type } = rule.criteria;
      switch (type) {
        case "between":
          return { valid: `${String(min)} - ${String(max)}` };
        case "younger":
          return { valid: `≤ ${String(value)}` };
        case "older":
          return { valid: `≥ ${String(value)}` };
        default:
          return null;
      }
    }),
};

module.exports = QuestionPrototype;
module.exports.SingleSelectPrototype = SingleSelectPrototype;
module.exports.RangeSelectPrototype = RangeSelectPrototype;
module.exports.DateOfBirthPrototype = DateOfBirthPrototype;
